module.exports = __webpack_public_path__ + "static/media/discuss-a-project-button-2.19f0b6f2.svg";